module.exports = __webpack_public_path__ + "img/fondo_nuestra_historia.649815ba.png";